import { useBreakpoint } from '@/common/hooks/use-breakpoint';
import { useEffect } from 'react';
import { logger } from '~/logger/logger';

export interface UsePDPAssembledPositionProps {
  assembledReady: boolean;
  ASSEMBLED_ENABLED: boolean;
}

export function usePDPAssembledPosition({
  assembledReady,
  ASSEMBLED_ENABLED,
}: UsePDPAssembledPositionProps) {
  const assembled = typeof window !== 'undefined' ? window.assembled : undefined;
  const breakpoint = useBreakpoint();

  const assembledActuallyReady =
    !!assembled &&
    typeof assembled.setPosition === 'function' &&
    (typeof assembled.isReady !== 'function' || assembled.isReady());

  const canUseAssembled = ASSEMBLED_ENABLED && (assembledReady || assembledActuallyReady);

  useEffect(() => {
    if (canUseAssembled && assembled?.setPosition) {
      try {
        assembled.setPosition({
          anchor: 'bottom-right',
          offsetX: 10,
          offsetY: breakpoint === 'desktop' ? 10 : 90,
        });
      } catch (error) {
        logger.error('Error setting Assembled position:', error);
      }
    }

    // Cleanup: Reset to default position when leaving PDP
    return () => {
      const currentAssembled =
        typeof window !== 'undefined' ? window.assembled : undefined;
      if (currentAssembled?.setPosition) {
        try {
          currentAssembled.setPosition({
            anchor: 'bottom-right',
            offsetX: 10,
            offsetY: 10,
          });
        } catch (error) {
          logger.error('Error resetting Assembled position:', error);
        }
      }
    };
  }, [canUseAssembled, assembled, breakpoint]);
}
